import * as u from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as r, transformBoolean as h } from "../../utilities/transformations.js";
import { getAspectCorrectedCoordinates as y } from "../../utilities/uv.js";
const C = {
  name: "Spiral5",
  collection: "spiral",
  tags: ["two-tone", "spiral"],
  props: {
    colorA: {
      type: String,
      default: "#fbcec4",
      transform: r,
      description: "The first color of the spiral"
    },
    colorB: {
      type: String,
      default: "#ef729a",
      transform: r,
      description: "The second color of the spiral"
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the spiral"
    },
    intensity: {
      type: Number,
      default: 1,
      description: "The intensity of bands in the spiral"
    },
    clockwise: {
      type: Boolean,
      default: !1,
      transform: h,
      description: "Whether the spiral should spin clockwise or not"
    }
  },
  fragmentNode: (e) => {
    const {
      vec4: n,
      time: s,
      length: i,
      atan2: l,
      mix: c,
      vec2: a
    } = u, p = 0.3, d = 0.3, { correctedUV: t, correctedCenter: o } = y(a(p, d)), m = i(t.sub(o)), f = l(
      t.y.sub(o.y),
      t.x.sub(o.x)
    ).add(m.mul(e.intensity.uniform).mul(20)).mul(1).add(s.mul(e.speed.uniform).mul(e.clockwise.uniform)).sin().mul(0.5).add(0.5);
    return n(
      c(
        e.colorA.uniform,
        e.colorB.uniform,
        f
      ),
      1
    );
  }
};
export {
  C as componentDefinition,
  C as default
};
